import React from "react";
import "./TermsofUse.css";

function TermsofUse() {
  return (
    <div className="termsofuse">
      <div className="container">
        <div className="termsofuse_text">
          <h1>Terms of use</h1>
          <hr />
          <div className="col-md-12 text-center">
            <p>
              By downloading or using K'Bro Application (the "Application"), a
              product offered by YouROK Corp. ("YouROK"), you signify your
              agreement to be bound by these terms and conditions and the
              Privacy Policy found here ( http://www.kbro.io/privacy_policy.html
              ) and incorporate herein by reference (collectively the "Terms").
              If you do not agree to any of these Terms, please do not access
              the Application or click the Accept button.
            </p>
            <p>
              You affirm that you are 13 years or older and possess legal
              parental or guardian consent, and are fully able and competent to
              enter into the terms, conditions, obligations, affirmations,
              representations, and warranties set forth in these Terms, and to
              bide by and comply with these Terms.
            </p>
            <h3>Disclaimer</h3>
            <p>
              K'Bro is not a medical or health services organization or forum.
              The information presented on this website and in the app is in no
              way intended as psychological and/or psychiatric advice, is not
              provided for the purpose of diagnostics or treating psychological
              and/or psychiatric problems nor is it a substitute for medical
              and/or psychiatric treatment. Use of this website does not
              establish a doctor-patient relationship. All information should be
              discussed and confirmed with your physician, psychologist,
              psychiatrist or other healthcare provider before adopting any
              wellness program, exercise program, or other treatment, whether
              offered on in the app, this website or otherwise. Information and
              statements regarding some of the products and/or services featured
              on this website have not been evaluated by the Food and Drug
              Administration and are not intended to diagnose treat, cure or
              prevent any disease.
            </p>
            <h3>The Application</h3>
            <p>
              The Application is a product you download on your mobile device
              and use at your discretion. The application is not hosted by
              K'Bro, except as set out below, including under the heading
              Privacy, Aggregated Data and Feedback. By using the Application,
              you expressly relieve K'Bro from any and all liability arising
              from your use of the Application. You may be bound by the terms
              and conditions of the provider of the Application from you have
              access the Application (the "Provider"). We have no control over,
              and assume no responsibility for, the content, privacy policies or
              practices of the Provider.
            </p>
            <p>
              You represent and warrant that all information you provide K'Bro
              on or through the Application, and otherwise, will be true,
              accurate, current and complete, and your agree to update such
              information as necessary to maintain its truth and accuracy.K'Bro
              reserves the right to modify, suspend or terminate the
              Application, your access to the Application, or any portion of the
              foregoing, at any time and for any reason, with or without notice.
            </p>
            <p>
              The application does not and is not intended to provide medical
              advice nor should it be deemed to be a substitute for medical
              care. You acknowledge that k'bro shall not be responsible for
              monitoring any medical information, including without limitation
              any health symptoms, adherence to prescribed medication use or
              similar information submitted by on or through the application.
              K'bro recommends that you consult your medical adviser or
              physician before using the application.
            </p>
            <h3>Privacy, Aggregated data and Feedback</h3>
            <p>
              K'Bro may, on or through the Application, provide you with an
              option enabling you to share data with K'Bro, in anonymized form,
              reflecting your access of, use of, uploads to, interactions with
              and/or activities on the Application (the "Anonymized Data"). By
              enabling the sharing of your Anonymized Data you: (i) agree to the
              collection of such Anonymized data; (ii) acknowledge an degree
              that such Anonymized Data share become K'Bro's property without
              any compensation payable to you by K'Bro; and (iii) acknowledge
              and agree that K'Bro shall be entitle to use such Anonymized data
              in accordance with these Terms. If you do not enable the sharing
              of your Anonymized Data, K'Bro will not access or store
              information related to your use of the Application..
            </p>
            <p>
              You acknowledge and agree that any ideas, suggestions, concepts,
              processes, techniques, enhances requests, recommendations, test
              results, data information and other output or feedback which you
              provide to K'Bro related to the Application, K'Bro or K'Bro's
              business ("Feedback"), shall become K'Bro's property without any
              compensation payable to you, and you assign all rights on a
              worldwide basis in any Feedback and, as applicable, waive any
              related moral rights therein.Any personal Information (as defined
              under the United States Freedom information and Protection of
              Privacy Act), obtained by K'Bro shall be used in accordance with
              these Terms. K'Bro strongly recommends that you keep your Personal
              Information an all information regarding the usage of the
              Application secure and protected to avoid an inadvertent
              disclosure to third parties or access by third parties.
            </p>
            <h3>Permissions and restrictions</h3>
            <p>
              You may not use the Application in any manner that infringes any
              third party's privacy rights, publicity rights, defamation rights,
              intellectual property rights, contract rights or any other rights
              of any person.
            </p>
            <p>
              You agree not to coy, modify, alter, change, translate, decrypt,
              obtain or extract the source code of, create derivative works
              from, reverse engineer, reverse assemble, decompile, disassemble
              or reverse compile any part of the Application.
            </p>
            <p>
              You may not use the Application in any manner to interfere with,
              or ate to interfere with the Application or other networks or
              services connected to the Application, whether through the use of
              viruses, bots, worms or any other computer code, files or programs
              that interrupt, destroy or limit the functionality of any computer
              software hardware, or otherwise permit such activity. You agree
              not use of launch any automated system using the Application,
              including without limitation a "robot" or "spider" that accesses
              the Application.
            </p>
            <p>
              You must use the Application in a manner consistent with any and
              all applicable law and regulations.
            </p>
            <h3>DISCLAIMER OF WARRANTIES AND LIMITATIONS OF LIABILITY</h3>
            <p>
              You agree that your use of the application and access to all
              content forming part or related to the application shall be at
              your sole risk, the application is provided on an "as is" and "as
              available" basis and is not intended to be a substitute for
              medical care or a tool for obtaining medical advice to the fullest
              extent permitted by law, K'bro and its officers, directors,
              employees, and agents, disclaim all warranties and conditions,
              express or implied or statutory, in connection with the
              application and your use thereof, including without limitation any
              implied warranties for conditions of mechantability, fitness for a
              particular purpose, accuracy, completeness, performance, Harvard
              compatibility, quiet enjoyment, title and non-infringement.
            </p>
            <p>
              In no event shall K'bro or its officers, directors, employees, or
              agents be liable to you for any indirect, incidental, special,
              punitive, or consequential damages or loss of revenue, income,
              profit, reputation or goodwill, whatsoever resulting from your use
              of or access to the application, including without limitation
              resulting from any: (i) errors, mistakes, inaccuracies or
              omissions in the application, (ii)personal injury or property
              damage of any nature whatsoever, resulting from your access to or
              use of application , (iii) unauthorized access to or use of the
              application, (iv) bugs, viruses, Trojan horses, or the like which
              may be transmitted to or through the application by any third
              party, or (v) errors, mistakes, inaccuracies or omissions in any
              content or for any loss or damage of any kind incurred as a result
              of the use of the application, whether based on warranty,
              contract, tort, misrepresentation or any other legal theory, and
              whether or not the affected parties are aware or have been advised
              of the possibility of such damages.
            </p>
            <p>
              The total aggregate liability of K'bro for any and all claims
              related to the terms shall not exceed us$100. any action commenced
              against K'bro for any and all claims related to the terms, shall
              be brought within twelve (12) months after such cause of action
              shall first arisen.
            </p>
            <p>
              K'bro makes no warranties or representations, about the accuracy
              or completeness of any sites, applications, pages or services of
              any kind linked to or through the application. K'bro does not
              warrant, endorse, guarantee or assume responsibility for any
              product or service advertised or offered by a third-party through
              the application or any hyperlinked service or website feature in
              any user submission, banner, sponsor message or other advertising.
              K'bro shall not be a party to or in any way be responsible for
              monitoring any transaction between you and other users of the
              application or any third-party providers of products or services.
            </p>
            <h3>Indemnity</h3>
            <p>
              You agree to defend, indemnify and hold harmless K'Bro and their
              respective officers, directors, employees and agents, from and
              against any and all claims, damages, obligations, losses,
              liabilities, costs or debt, and expenses (including but not
              limited to attorney's fees) arising from (i) your use of or access
              to the Application; (ii) your violation of any third party right,
              including, without limitation any copyright, property, or privacy
              right. This defense and indemnification obligation will survive
              these Terms and your use of the Application.
            </p>
            <h3>Assignment</h3>
            <p>
              These Terms, and any rights and licenses granted hereunder, may
              not be transferred or assigned by you, but may be assigned by
              K'Bro without restriction.
            </p>
            <h3>General</h3>
            <p>
              If there is any disputed between and K'Bro about or involving
              these Terms, you hereby agree that the dispute shall be governed
              by and construed in accordance with the laws of the State of
              California without regard to its conflict of law provisions. You
              hereby agree to submit to the exclusive jurisdiction of the courts
              of the State of California with respect to any claim, proceeding
              or action relating to or otherwise arising out of these Terms or
              your access to or use of the Application, howsoever arising,
              provided always that K'Bro may seek and obtain injunctive relief
              (or an equivalent type of urgent legal relief) in any
              jurisdiction.
            </p>
            <p>
              If any provision of these Terms is deemed invalid by a court of
              competent jurisdiction, the invalidity of such provision shall not
              affect the validity of the remaining provisions of these Terms,
              which shall remain in full force and effect. No waiver of any
              terms of these Terms shall be deed a further or continuing waiver
              of such term of any other term, and K'Bro's failure to assert any
              right or provision under these Terms shall constitute a waiver of
              such right or provision. K'Bro reserves the right to amend these
              Terms at any time and without notice, and it is your
              responsibility to review these terms for any changes. Your
              continued use of the Application following amendment of the Terms
              shall signify your ascent to, and acceptance of, such amended
              Terms.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsofUse;
